import {
  BOLD_ITALIC_STAR,
  BOLD_ITALIC_UNDERSCORE,
  BOLD_STAR,
  BOLD_UNDERSCORE,
  ITALIC_STAR,
  ITALIC_UNDERSCORE,
  LINK,
  QUOTE,
  ORDERED_LIST,
  STRIKETHROUGH,
  UNORDERED_LIST,
} from "@lexical/markdown";
import { MarkdownShortcutPlugin } from "@lexical/react/LexicalMarkdownShortcutPlugin";

export default function MarkdownPlugin(): JSX.Element {
  return (
    <MarkdownShortcutPlugin
      transformers={[
        QUOTE,

        UNORDERED_LIST,
        ORDERED_LIST,

        BOLD_ITALIC_STAR,
        BOLD_ITALIC_UNDERSCORE,
        BOLD_STAR,
        BOLD_UNDERSCORE,
        ITALIC_STAR,
        ITALIC_UNDERSCORE,
        STRIKETHROUGH,

        LINK,
      ]}
    />
  );
}
